/* 地図の図形 (SVG) のスタイル。SVG の中に埋め込み、離島の別枠 (<use> の複製) にも効かせる */
.neighbor { fill: #20262f; stroke: #2b323d; stroke-width: 0.6; vector-effect: non-scaling-stroke; fill-rule: evenodd; }
.pref { fill: var(--land); stroke: var(--land-edge); stroke-width: 0.8; vector-effect: non-scaling-stroke; fill-rule: evenodd; }
.pref.hit { stroke: #000; }
/* 気象警報・注意報 (平時)。レベル2 注意報 = 黄、レベル3 警報 = 赤、レベル4 危険警報 = 紫、レベル5 特別警報 = 黒 */
.warn { fill: none; stroke: none; }
.warn[data-level] { stroke: rgba(0, 0, 0, 0.35); stroke-width: 0.4; vector-effect: non-scaling-stroke; fill-rule: evenodd; }
.warn[data-level="advisory"] { fill: #f2e700; fill-opacity: 0.5; }
.warn[data-level="warning"] { fill: #ff2800; fill-opacity: 0.65; }
.warn[data-level="danger"] { fill: #aa00ff; fill-opacity: 0.7; }
.warn[data-level="emergency"] { fill: #0c000c; fill-opacity: 0.85; stroke: #fff; }
.pref.forecast { stroke: #fff; stroke-dasharray: 4 3; stroke-width: 1.2; }
.area { fill: none; stroke: rgba(255, 255, 255, 0.1); stroke-width: 0.5; vector-effect: non-scaling-stroke; fill-rule: evenodd; }
.area.hit { stroke: rgba(0, 0, 0, 0.6); fill-opacity: 0.55; }
.area.forecast { stroke: #fff; stroke-dasharray: 4 3; stroke-width: 1; }
.dot, .dot-bg { pointer-events: none; fill: none; stroke-linecap: round; vector-effect: non-scaling-stroke; }
.dot { stroke-width: 7px; }
.dot-bg { stroke: #000; stroke-width: 9.5px; }
.tsunami-line { fill: none; stroke: none; vector-effect: non-scaling-stroke; stroke-width: 5; stroke-linecap: round; stroke-linejoin: round; filter: drop-shadow(0 0 1.5px #000) drop-shadow(0 0 1px #000); }
.tsunami-line[data-grade="watch"] { stroke: var(--t-watch); }
.tsunami-line[data-grade="warning"] { stroke: var(--t-warning); }
.tsunami-line[data-grade="major_warning"] { stroke: var(--t-major); stroke-width: 7; }
.wave { pointer-events: none; fill: none; vector-effect: non-scaling-stroke; stroke-width: 2.5; }
.wave-p { stroke: var(--p-wave); }
.wave-s { stroke: var(--s-wave); fill: rgba(255, 82, 82, 0.05); }
.label { pointer-events: none; }
.label rect { stroke: rgba(0, 0, 0, 0.7); stroke-width: 1.5; }
.label.forecast rect { stroke: #fff; stroke-dasharray: 3 2; }
.label text { font-weight: 800; }
/* 予測 (緊急地震速報) の間だけ塗りと数字を点滅させ、観測の震度と見分ける */
@keyframes forecast-pulse-pref { 50% { fill-opacity: 0.35; } }
@keyframes forecast-pulse-area { 50% { fill-opacity: 0.2; } }
@keyframes forecast-pulse-label { 50% { opacity: 0.45; } }
.pref.hit.forecast { animation: forecast-pulse-pref 1.2s ease-in-out infinite; }
.zoomed.area-forecast .pref.hit.forecast { animation: none; }
.area.hit.forecast { animation: forecast-pulse-area 1.2s ease-in-out infinite; }
.label.forecast { animation: forecast-pulse-label 1.2s ease-in-out infinite; }
@media (prefers-reduced-motion: reduce) { .pref.forecast, .area.forecast, .label.forecast { animation: none; } }
.home-marker { pointer-events: none; }
/* 地震感知情報 (利用者の「揺れた」報告): 広がる輪。信頼度が低いほど薄く */
@keyframes uq-pulse { from { transform: scale(0.3); opacity: 0.9; } to { transform: scale(1.4); opacity: 0; } }
.userquake .uq-ring { fill: none; stroke: #7ee0ff; stroke-width: 2.5; transform-box: fill-box; transform-origin: center; animation: uq-pulse 1.6s ease-out infinite; }
.userquake .uq-dot { fill: #7ee0ff; stroke: #0b2530; stroke-width: 1.5; }
.userquake.grade-B { opacity: 0.85; }
.userquake.grade-C { opacity: 0.7; }
.userquake.grade-D { opacity: 0.55; }
.userquake.grade-E, .userquake.grade-F { opacity: 0.4; }
@media (prefers-reduced-motion: reduce) { .userquake .uq-ring { animation: none; } }
.home-ring { fill: none; stroke: #fff; stroke-width: 2.5; }
.home-dot { fill: #58a6ff; stroke: #fff; stroke-width: 1.5; }
.epicenter[data-key] { cursor: pointer; }
.epicenter-hit { fill: transparent; stroke: none; pointer-events: all; }
.epicenter-x { stroke: #ff1744; stroke-width: 4; stroke-linecap: round; fill: none; }
.epicenter-x-bg { stroke: #fff; stroke-width: 8; stroke-linecap: round; fill: none; }
.epicenter.sub { opacity: 0.8; }
/* 後の報で分かった震源: 薄く点線で */
.epicenter.ghost { opacity: 0.6; }
.epicenter.ghost .epicenter-x { stroke-dasharray: 5 6; }
.epicenter-label { font-size: 15px; font-weight: 700; fill: #fff; stroke: #000; stroke-width: 4px; paint-order: stroke; }
.epicenter-pulse { fill: none; stroke: #ff1744; stroke-width: 2; animation: pulse 1.6s ease-out infinite; transform-box: fill-box; transform-origin: center; }
@keyframes pulse { from { transform: scale(0.4); opacity: 1; } to { transform: scale(2.2); opacity: 0; } }
/* 平時の天気: アメダスの雨の地点と、主要都市の天気・気温 */
.rain-dot { pointer-events: none; fill: none; stroke-linecap: round; vector-effect: non-scaling-stroke; stroke-width: 5px; opacity: 0.9; }
.city .city-dot { fill: #fff; stroke: #000; stroke-width: 1; }
/* 札は明るい地にして、絵文字 (傘など) が暗い地に沈まないように。下の警報・注意報の塗りが透けるよう、少し透かす */
.city .city-box { fill: rgba(240, 244, 248, 0.8); stroke: rgba(0, 0, 0, 0.55); stroke-width: 1; }
.city .city-text { font-size: 13px; font-weight: 700; fill: #0d1117; }
.city .city-pop { font-size: 11px; fill: #1e5aaa; }
/* 重なって動かした札と点をつなぐ線。暗い地図に沈まないよう札の地と同じ明るい色で、細く */
.city .city-leader { stroke: rgba(240, 244, 248, 0.85); stroke-width: 1.2; }
/* 狭い画面で置き場がなく間引いた札 (点は残す) */
.city.thin .city-badge, .city.thin .city-leader { display: none; }

/* 寄ったとき (.base.detail) は都道府県の塗りをやめ、細分区域と観測点で描く。
   別枠は <use> の複製で、外の CSS (.map.zoomed) が効かないので、図形の束に付けたクラスで切り替える */
.base:not(.detail) .areas, .base:not(.detail) .dots { display: none; }
.base.detail .pref { fill: var(--land) !important; stroke: #5a6474; }
